import { filterByMarket, navConfig, type Market } from "./navigation/navConfig";
import { Navigation } from "./navigation/Navigation";
import { useGlobalContext } from "@utils/GlobalContext";

export const Header = ({ market: marketProp }: { market?: Market } = {}) => {
  const { region, activeRegion } = useGlobalContext();
  const market = marketProp ?? ((activeRegion as Market) ?? (region as Market));

  return <Navigation root={filterByMarket(navConfig, market)} loading={false} />;
};
